import { getClusterContinent } from '@/components/form/location-selector/continents'
import type { ContinentCode } from '@/components/form/location-selector/continents'

const continentTimezoneMap: Record<ContinentCode, string> = {
  northamerica: 'america',
  southamerica: 'america',
  europe: 'europe',
  africa: 'africa',
  asia: 'asia',
  australia: 'australia',
  me: 'asia',
}

export const findClosestCluster = (
  clusters: {
    id: string
    location: string
  }[]
) => {
  const visitorTimezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone
  const [continent = ''] = visitorTimezone?.split('/') ?? []
  const visitorContinent = continent.toLowerCase()

  if (clusters.length === 1) {
    return clusters[0]
  }

  return (
    clusters.find((cluster) => {
      const clusterContinent = getClusterContinent(cluster.location)

      return (
        clusterContinent !== null &&
        continentTimezoneMap[clusterContinent] === visitorContinent
      )
    }) ||
    clusters.find(
      (cluster) => getClusterContinent(cluster.location) === 'europe'
    ) ||
    clusters[0]
  )
}
